// PostDraftList.js
'use strict';
import { connect } from 'react-redux';

import PostDraftList from '../component/PostDraftList.jsx';
import getUploadJobIds from '../selector/getUploadJobIds.js';

const mapStateToProps = (state, { mediaTypesString, uploadJobType }) => {
  const uploadJobIds = getUploadJobIds(state, uploadJobType, mediaTypesString);
  return {
    uploadJobIds,
  };
};

export default connect(mapStateToProps, null)(PostDraftList);
